import { render, staticRenderFns } from "./LocationGlobalSpecialClosuresDialog.vue?vue&type=template&id=510a917a"
import script from "./LocationGlobalSpecialClosuresDialog.vue?vue&type=script&lang=js"
export * from "./LocationGlobalSpecialClosuresDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports